import lodash from "lodash";
import { FC } from "react";
import { classNames } from "utils";
import { IMeterDeliveryRequestFormSchema } from "./schema";
import { columns, headerMap } from './meters-info-form';

export interface MetersInfoFormProps {
  data: IMeterDeliveryRequestFormSchema["metersInfo"];
  values: IMeterDeliveryRequestFormSchema;
}

const MetersInfoForm: FC<
  MetersInfoFormProps
> = ({ data }) => {

  return (
    <div className="flex flex-1 flex-col border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
      <div className=''>
        <span className="text-xs font-light">Meter Enclosure Information</span>
        <div className='grid grid-cols-3 gap-6 mt-2'>
          <div className="col-span-1">
            <span className="block text-sm font-light text-gray-700">
              Single-Phase Meter Enclosures
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {data?.singlePhaseMeterEnclosures || "N/A"}
            </div>
          </div>
          <div className="col-span-1">
            <span className="block text-sm font-light text-gray-700">
              Three-Phase Meter Enclosures
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {data?.threePhaseMeterEnclosures || "N/A"}
            </div>
          </div>
          <div className="col-span-1">
            <span className="block text-sm font-light text-gray-700">
              Total Number of Meter Enclosures
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {(data?.singlePhaseMeterEnclosures || 0) +
                (data?.threePhaseMeterEnclosures || 0) || "N/A"}
            </div>
          </div>
        </div>
      </div>
      {data.testSets.map((testSet, idx) => (
        <div className='pt-4' key={idx}>
          <span className="text-xs font-light">Test Set {idx  + 1} Information</span>
          <div className='grid grid-cols-4 gap-6 mt-2'>
            <div className="col-span-1">
              <span className="block text-sm font-light text-gray-700">
                Quantity
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {testSet.content?.length || "N/A"} Meters
              </div>
            </div>
            <div className="col-span-1">
              <span className="block text-sm font-light text-gray-700">
                Meter Phase
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {testSet.meterPhase || "N/A"}
              </div>
            </div>
            <div className="col-span-1">
              <span className="block text-sm font-light text-gray-700">
                Meter Brand
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {testSet.meterBrand?.name || "N/A"}
              </div>
            </div>
            <div className="col-span-1">
              <span className="block text-sm font-light text-gray-700">
                Meter Model
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {testSet.meterModel?.name || "N/A"}
              </div>
            </div>
            <div className={"max-h-[300px] overflow-y-auto col-span-4"}>
              <table className=" min-w-full  divide-y divide-gray-200">
                <thead className="bg-gray-50 sticky top-0 z-10 border-b">
                <tr>
                  {columns?.map((column: any, idx: number) => (
                    <th
                      scope="col"
                      key={idx}
                      className={classNames(
                        idx === 0 ? "sticky left-0 bg-gray-50" : "",
                        "px-6 py-3 mt-0 text-left text-xs font-medium whitespace-nowrap text-gray-500 uppercase tracking-wider"
                      )}
                    >
                      {lodash.get(headerMap, column)}
                    </th>
                  ))}
                </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {testSet.content?.map((item, key) => {
                    return (
                      <tr key={key}>
                        {columns?.map((column, idx) => {
                          return (
                            <td
                              key={idx}
                              className={classNames(
                                idx === 0 ? "sticky left-0 bg-gray-50" : "",
                                "px-6 py-4 whitespace-nowrap text-sm ",
                                "text-gray-500"
                              )}
                            >
                              {lodash.get(item, column, "N/A")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}

    </div>
  );
};

export default MetersInfoForm;
